// Primary backend URL. Accepts either VITE_API_URL or VITE_BACKEND_URL so that
// either naming convention works at build time and stays consistent with callers
// that may reach for `import.meta.env.VITE_API_URL` directly.
const API_URL =
    (import.meta as any).env?.VITE_API_URL ||
    (import.meta as any).env?.VITE_BACKEND_URL ||
    "http://localhost:4000";

export const BACKEND_URL = API_URL;
export { API_URL };
export const FRONTEND_URL = (import.meta as any).env?.VITE_FRONTEND_URL || "http://localhost:3053";
export const GRAPHQL_URL = (import.meta as any).env?.VITE_GRAPHQL_URL || `${API_URL}/graphql`;
export const SOCKET_URL = (import.meta as any).env?.VITE_SOCKET_URL || API_URL;
export const WIDGET_CDN_URL = (import.meta as any).env?.VITE_WIDGET_CDN_URL || API_URL;

// Cloudflare Turnstile sitekey. Falls back to Cloudflare's public always-passes
// test key so the captcha flow works in dev without provisioning real keys.
export const TURNSTILE_SITE_KEY =
    (import.meta as any).env?.VITE_TURNSTILE_SITE_KEY || "1x00000000000000000000AA";

// Shopify data collections are hidden while the Shopify app is in review
// (backend enforces the same via SHOPIFY_DATA_COLLECTIONS_ENABLED). Tracked
// in docs/shopify/shopify-bug-feature-list.md — not meant to stay off.
export const SHOPIFY_DATA_COLLECTIONS_ENABLED =
    (import.meta as any).env?.VITE_SHOPIFY_DC_ENABLED === "true";
